import { useMemo } from "react";

const WHATS_NUMBER_E164 = "554137979092"; // +55 41 3797-9092
const WHATS_TEXT = "Olá! Quero o projeto gratuito para meu condomínio.";

export default function CTA() {
  const waLink = useMemo(
    () => `https://wa.me/${WHATS_NUMBER_E164}?text=${encodeURIComponent(WHATS_TEXT)}`,
    []
  );

  return (
    <section id="cta" className="relative overflow-hidden py-14 md:py-18">
      {/* fundo */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div
          className="absolute -left-24 top-0 h-[30rem] w-[30rem] rounded-full blur-3xl opacity-[.22]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,0,100,.55) 0%, rgba(255,0,100,0) 60%)" }}
        />
        <div
          className="absolute right-[-8rem] bottom-[-10rem] h-[38rem] w-[38rem] rounded-full blur-3xl opacity-[.18]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,77,145,.45) 0%, rgba(255,77,145,0) 60%)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40" />
      </div>

      <div className="max-w-6xl mx-auto px-4">
        <div className="relative grid gap-8 md:grid-cols-2 items-center">
          {/* Texto */}
          <div className="md:pt-1">
            <h3 className="text-3xl md:text-4xl font-extrabold">
              Projeto gratuito para o seu condomínio
            </h3>
            <p className="mt-3 text-white/85">
              Projeto óptico + plano de ativação por unidade. <strong>Sem custo de implantação</strong> para o condomínio.
            </p>

            {/* Botão único: WhatsApp com glow pulsante (sem verde) */}
            <div className="mt-7">
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                className="whats-btn group inline-flex items-center gap-3 rounded-2xl px-5 py-3.5 text-[15.5px] font-semibold text-white"
                aria-label="Continuar pelo WhatsApp: +55 41 3797-9092"
              >
                {/* ícone centralizado e simétrico */}
                <span className="grid h-8 w-8 place-items-center rounded-full bg-white/15 ring-1 ring-inset ring-white/25">
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"    // sólido
                    aria-hidden="true"
                  >
                    <path d="M20.5 4.5A9.5 9.5 0 0 0 4.3 18.1L3 22l4.1-1.3A9.5 9.5 0 1 0 20.5 4.5Z" opacity=".2" />
                    <path fill="currentColor" d="M8.2 9.8c.1 3 2.9 5.6 5.9 5.9.7.1 1.6-.2 2.2-.6.2-.1.3-.4.2-.6l-.8-1.9a.6.6 0 0 0-.7-.3l-1 .3a1.4 1.4 0 0 1-1.2-.3l-1.4-1.4a1.4 1.4 0 0 1-.3-1.2l.3-1a.6.6 0 0 0-.3-.7l-1.9-.8c-.2-.1-.5 0-.6.2-.4.6-.7 1.4-.6 2.1Z" />
                  </svg>
                </span>
                <span>Falar no WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Cartão simples com o número */}
          <div className="relative rounded-3xl p-6 md:p-7 bg-white/5 backdrop-blur-xl ring-1 ring-white/10 shadow-card">
            <h4 className="text-xl font-semibold">Atendimento imediato</h4>
            <p className="mt-2 text-white/75">
              Abrimos sua conversa direto com nossa equipe comercial para agilizar o <em>kickoff</em>.
            </p>
            <div className="mt-5 grid gap-2 text-sm">
              <div className="flex items-center justify-between rounded-xl border border-white/10 bg-white/[.04] px-4 py-3">
                <span className="text-white/70">WhatsApp</span>
                <a href={waLink} target="_blank" rel="noreferrer" className="font-semibold text-white hover:underline">
                  +55 41 3797-9092
                </a>
              </div>
              <p className="text-xs text-white/55">Horário comercial — resposta rápida.</p>
            </div>
          </div>
        </div>
      </div>

      {/* CSS do botão com glow pulsante; sem shear/sheen */}
      <style>{`
        .whats-btn {
          position: relative;
          background: linear-gradient(90deg, #FF0064 0%, #ff4d91 100%);
          box-shadow:
            0 10px 26px -16px rgba(255,0,100,.45),
            inset 0 0 0 1px rgba(255,255,255,.12);
          transition: box-shadow .2s ease, transform .15s ease;
          animation: glowPulse 3.8s ease-in-out infinite;
          will-change: transform, box-shadow;
        }
        .whats-btn:hover {
          transform: translateY(-1px);
          box-shadow:
            0 18px 38px -16px rgba(255,0,100,.55),
            inset 0 0 0 1px rgba(255,255,255,.16);
        }
        .whats-btn:active { transform: translateY(0); }

        /* glow pulsando suavemente */
        @keyframes glowPulse {
          0%, 100% {
            box-shadow:
              0 10px 26px -16px rgba(255,0,100,.42),
              inset 0 0 0 1px rgba(255,255,255,.12);
          }
          50% {
            box-shadow:
              0 26px 60px -18px rgba(255,0,100,.62),
              inset 0 0 0 1px rgba(255,255,255,.18);
          }
        }

        /* respeita reduzir movimento */
        @media (prefers-reduced-motion: reduce) {
          .whats-btn { animation: none; transition: none; }
        }
      `}</style>
    </section>
  );
}
